import React from 'react';
import GetAppIcon from '@mui/icons-material/GetApp';
import Logout from './logout.svg';
import { ReactComponent as PhoneIcon } from '@zonofi/svg-icons/phone-icon.svg';
import { ReactComponent as EmailIcon } from '@zonofi/svg-icons/envelope.svg';

interface DrawerFooterProps {
  canInstall?: boolean;
  onInstall?: () => void;
  onLogout: () => void;
  appVersion?: string;
}

export const DrawerFooter: React.FC<DrawerFooterProps> = ({
  canInstall,
  onInstall,
  onLogout,
  appVersion,
}) => {
  return (
    <div className="side-drawer-footer font-regular">
      <div className="side-drawer-list">
        {canInstall && (
          <div className="install-btn font-semibold" onClick={onInstall}>
            <GetAppIcon height={20} width={20} />
            Install as App
          </div>
        )}
      </div>

      <div className="logout-btn font-semibold" onClick={onLogout}>
        <img src={Logout} alt="logout icon" height={20} width={20} />
        Logout
      </div>

      <div className="side-drawer-divider" />

      <div className="contact-container">
        <div className="side-drawer-contact-label">Contact Us</div>
        <div className="contact-row">
          <div className="contact-row-item">
            <PhoneIcon height={16} width={16} />
            <a className="side-drawer-contact-link" href="tel:+917893051518">
              +91 - 7893051518
            </a>
          </div>
          <div className="contact-row-item"> | </div>
          <div className="contact-row-item">
            <EmailIcon height={16} width={16} />
            <a
              className="side-drawer-contact-link"
              href="mailto:support@zotok.ai"
            >
              support@zotok.ai
            </a>
          </div>
        </div>
        <div className="side-drawer-powered">
          Powered by <span>ZoTok</span>
          {appVersion && ' | '}
          {appVersion && <span>{`v ${appVersion}`}</span>}
        </div>
      </div>
    </div>
  );
};
